import { render, staticRenderFns } from "./HelloWorld copy.vue?vue&type=template&id=78145339&scoped=true"
import script from "./HelloWorld copy.vue?vue&type=script&lang=js"
export * from "./HelloWorld copy.vue?vue&type=script&lang=js"
import style0 from "./HelloWorld copy.vue?vue&type=style&index=0&id=78145339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78145339",
  null
  
)

export default component.exports